module.exports = __webpack_public_path__ + "img/eye.800f9b77.svg";